export type HopperInfoState = {
  ownerInfo: any;
  ownerInfoErrorCode: any;
};

export enum Actions {
  API_LOADING = "API_LOADING",
  SETDATA = "SETDATA",
  ERROR = "ERROR",
}

export type HopperInfoAction = {
  type: Actions;
  payload: any;
};

export const InitState: HopperInfoState = {
  ownerInfo: "",
};

export enum PageErrorType {
  "apiError" = "apiError",
}
